import { render, staticRenderFns } from "./DailyReceivedDate-Stacked.vue?vue&type=template&id=afd3c726&"
import script from "./DailyReceivedDate-Stacked.vue?vue&type=script&lang=js&"
export * from "./DailyReceivedDate-Stacked.vue?vue&type=script&lang=js&"
import style0 from "./DailyReceivedDate-Stacked.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports